exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".side-icon[data-v-86d874f0] {\n  margin-right: 20px;\n}\n.two-line-list-item.two-line-list-item[data-v-86d874f0] a {\n  height: 80px;\n}\n.logo-btn[data-v-86d874f0] .v-btn__content {\n  height: 100%;\n}\n.logo[data-v-86d874f0] {\n  padding: 10px 0;\n  height: 100%;\n  width: auto;\n}\n", ""]);

